import classes from "./Spinner.module.css";

const Spinner = () => {
  return <div className={classes.loader}>spinner</div>;
};

export default Spinner;
